import { useEffect } from 'react';
import {
    Dialog,
    DialogTrigger,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogFooter,
} from "./ui/dialog"

import { Button } from "./ui/button"
import { useState } from "react"

export function ModalTresBotoes() {
    const [open, setOpen] = useState(false)

    useEffect(() => {
        const fn = () => setOpen(true)
        window.addEventListener("open-pred-modal", fn)
        return () => window.removeEventListener("open-pred-modal", fn)
    }, [])

    function handleSalvar() {
        (window as any)["StatePresets"]("save");
        setOpen(false)
    }

    function handleResetar() {
        (window as any)["StatePresets"]("reset");
        setOpen(false)
    }

    function handleCancelar() {
        setOpen(false)
    }

    return (
        <Dialog open={open} onOpenChange={setOpen}>
            {/*<DialogTrigger asChild>
                <Button>Abrir modal</Button>
            </DialogTrigger>*/}

            <DialogContent>
                <DialogHeader>
                    <DialogTitle>Predefinições</DialogTitle>
                </DialogHeader>

                <div className="py-4">
                    Você pode salvar a posição do modelo, da cãmera, estado do clone, estado das partes e fundo para abrir por padrão.
                </div>

                <DialogFooter className="flex justify-between">
                    <Button
                        variant="destructive"
                        onClick={handleResetar}
                    >
                        Resetar
                    </Button>

                    <div className="flex gap-2">
                        <Button
                            variant="outline"
                            onClick={handleCancelar}
                        >
                            Cancelar
                        </Button>

                        <Button
                            onClick={handleSalvar}
                        >
                            Salvar
                        </Button>
                    </div>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    )
}
